import { createContext, useContext } from "react";

/**
 * Opens the order list's card view over the given orders. The list's columns are built once at
 * module scope, so a row's View Cards button reaches the page's dialog through this context rather
 * than a closure over page state.
 */
export const OpenOrderCardsContext = createContext<((orderIds: string[]) => void) | null>(null);

/**
 * The page's card-view opener, for a cell rendered inside its table. Throws outside the provider,
 * so a View Cards button with no dialog to open fails loudly rather than doing nothing.
 */
export function useOpenOrderCards(): (orderIds: string[]) => void {
  const open = useContext(OpenOrderCardsContext);
  if (!open) throw new Error("useOpenOrderCards needs an OpenOrderCardsContext provider");
  return open;
}
